import React from "react";
import { ButtonFluxiProps } from "./ButtonFluxiInterface";

export const ButtonFluxi: React.FC<ButtonFluxiProps> = ({
  icon,
  text = "",
  onClick,
  children,
  fullWidth = false,
  isEffect = true,
  style = {},
  disabled = false,
  type = "submit",
  border_color = "transparent",
  color = "white",
}) => {
  return (
    <button
      type={type}
      className={`
        flex
        items-center
        px-5 py-3
        text-[15px] font-medium
        rounded-full
        transition-all
        relative
        overflow-hidden
        gap-2
        ${border_color !== "transparent" ? "border" : ""}
        ${disabled ? "opacity-50 cursor-not-allowed" : "hover:shadow-lg"}`}
      style={{
        background: "linear-gradient(135deg, rgb(67, 104, 229), rgb(47, 110, 218))",
        boxShadow: "0 4px 12px rgba(47, 110, 218, 0.3)",
        ...style,
        width: fullWidth ? "100%" : "auto",
        justifyContent: "center",
        color: color,
        borderColor: border_color,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className="relative z-10">{icon}</span>}
      {text && <span className="relative z-10">{text}</span>}
      {children}
      {isEffect && <div className="absolute inset-0 bg-white/20 skew-x-[-45deg] translate-x-[-100%] animate-shine" />}
    </button>
  );
};
